"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isElementOrChildOf = exports.BOGUS_BR = void 0;
var BOGUS_BR = '<br data-mce-bogus="1">';
exports.BOGUS_BR = BOGUS_BR;

var isElementOrChildOf = function isElementOrChildOf(el, findEl) {
  if (!el || !findEl) {
    return false;
  }

  if (el === findEl) {
    return true;
  }

  do {
    if (el === findEl) {
      return true;
    }

    el = el.parentElement;
  } while (el);

  return false;
};

exports.isElementOrChildOf = isElementOrChildOf;